/**
 * 見取り図の保存で、背景画像を読み込めなかった見取り図を編集前の内容に戻す。
 *
 * 見取り図の保存は、既存の合成画像（floor_plan_image_url）を消してからキャンバスを撮り直す。
 * 背景画像を読み込めていない（署名付き URL の期限切れ・通信の失敗など）と、背景の無い画像で
 * 置き換わり、消した合成画像は戻せない（保存先のバケットにバージョン管理が無い）。
 * そこで、その見取り図だけ編集前の値（json_data・background_image_url・floor_plan_image_url）の
 * まま保存し、撮り直しも削除もしない。ほかの項目と、ほかの見取り図はふだんどおり保存する。
 */

/** 保存のあとに出す案内 */
export const KEPT_FLOOR_PLAN_MESSAGE =
  "背景画像を読み込めなかった見取り図があったため、その見取り図は編集前のまま残しました（ほかの項目は保存しました）。" +
  "画面を開き直してから、もう一度見取り図を編集してください。";

type FloorPlanEditorRefLike = { hasBackgroundLoadError?: () => boolean } | null | undefined;

/**
 * 背景画像を読み込めなかった見取り図を、その場で編集前の内容に置き換える。
 *
 * @param plans 保存する見取り図（この配列の要素を置き換える）
 * @param originalPlans 編集を始めたときの見取り図
 * @param editorRefs 見取り図の ID ごとのエディタの参照
 * @returns 編集前のまま残した見取り図の ID（保存処理はこの ID の撮り直し・削除を飛ばす）
 */
export function keepFloorPlansWithBackgroundLoadError<T extends { id: number }>(
  plans: T[],
  originalPlans: ReadonlyArray<T> | null | undefined,
  editorRefs: { [id: number]: FloorPlanEditorRefLike },
): Set<number> {
  const kept = new Set<number>();
  plans.forEach((plan, index) => {
    if (!editorRefs[plan.id]?.hasBackgroundLoadError?.()) return;
    const original = originalPlans?.find((p) => p.id === plan.id);
    // 編集前の値が無い（編集中に足した見取り図など）ときは戻しようがないので、ふだんどおり保存する
    if (!original) return;
    plans[index] = JSON.parse(JSON.stringify(original));
    kept.add(plan.id);
  });
  return kept;
}
